var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: true,
        closable: true,
        footer: null,
        width: 700,
        centered: "",
        wrapClassName: "auto-rebalance-promo-modal",
      },
      on: { cancel: _vm.handleClose },
    },
    [
      _c("div", { staticClass: "auto-rebalance-promo" }, [
        _c("div", { staticClass: "promo-header" }, [
          _c("div", { staticClass: "icon-container" }, [
            _c("span", { staticClass: "material-icons" }, [
              _vm._v("autorenew"),
            ]),
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("Otomatik Bakiye Yükleme")]),
          _vm._v(" "),
          _c("p", { staticClass: "subtitle" }, [
            _vm._v(
              "Sürekli bakiye yüklemekten yorulmadın mı? Otomatik bakiye yüklemeyi aktif et ve hizmet kesintisi yaşamadan devam et!"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "promo-content" }, [
          _c("div", { staticClass: "features-grid" }, [
            _c("div", { staticClass: "feature-card" }, [
              _c("div", { staticClass: "feature-icon red" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("notifications_active"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "feature-text" }, [
                _c("strong", [_vm._v("Bakiye Bittiğinde Fark Etme")]),
                _vm._v(" "),
                _c("span", [_vm._v("Hizmet kesilmeden otomatik yüklenir")]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "feature-card" }, [
              _c("div", { staticClass: "feature-icon blue" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("refresh"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "feature-text" }, [
                _c("strong", [_vm._v("Sürekli Takip Etmeyin")]),
                _vm._v(" "),
                _c("span", [_vm._v("Sistem sizin yerinize halleder")]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "feature-card" }, [
              _c("div", { staticClass: "feature-icon green" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("check_circle"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "feature-text" }, [
                _c("strong", [_vm._v("Chatbot & WhatsApp Kesintisiz")]),
                _vm._v(" "),
                _c("span", [_vm._v("AI ve mesajlar hiç durmaz")]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "how-it-works" }, [
            _c("div", { staticClass: "steps-container" }, [
              _c("div", { staticClass: "step" }, [
                _c("div", { staticClass: "step-number" }, [_vm._v("1")]),
                _vm._v(" "),
                _c("div", { staticClass: "step-content" }, [
                  _c("strong", [_vm._v("Eşik Değer")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Örn: 250 TL")]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step-arrow" }, [_vm._v("→")]),
              _vm._v(" "),
              _c("div", { staticClass: "step" }, [
                _c("div", { staticClass: "step-number" }, [_vm._v("2")]),
                _vm._v(" "),
                _c("div", { staticClass: "step-content" }, [
                  _c("strong", [_vm._v("Hedef Bakiye")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Örn: 500 TL")]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step-arrow" }, [_vm._v("→")]),
              _vm._v(" "),
              _c("div", { staticClass: "step" }, [
                _c("div", { staticClass: "step-number" }, [_vm._v("3")]),
                _vm._v(" "),
                _c("div", { staticClass: "step-content" }, [
                  _c("strong", [_vm._v("Otomatik")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Yükleme")]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "promo-actions" },
            [
              _c(
                "a-button",
                {
                  staticClass: "activate-btn",
                  attrs: { type: "primary", size: "large" },
                  on: { click: _vm.handleActivate },
                },
                [
                  _c("span", { staticClass: "btn-content" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("rocket_launch"),
                    ]),
                    _vm._v(
                      "\n                        Hemen Başla\n                    "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                { staticClass: "later-btn", on: { click: _vm.handleClose } },
                [_vm._v("\n                    Daha Sonra\n                ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "reminder-checkbox" },
            [
              _c(
                "a-checkbox",
                {
                  model: {
                    value: _vm.dontShowAgain,
                    callback: function ($$v) {
                      _vm.dontShowAgain = $$v
                    },
                    expression: "dontShowAgain",
                  },
                },
                [
                  _vm._v(
                    "\n                    Bu mesajı tekrar gösterme\n                "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }